import { createI18n, type I18nOptions } from "vue-i18n";
import localeMessages from "@/app/locales/index";
import { App } from "vue";

import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import th from 'i18n-iso-countries/langs/th.json';

countries.registerLocale(en);
countries.registerLocale(th);

const legacy: boolean = false;
const globalInjection: boolean = true;
const locale: string = process.env.VUE_APP_I18N_LOCALE || "th";
const fallbackLocale: string = process.env.VUE_APP_I18N_FALLBACK_LOCALE || "th";

export default createI18n({
  legacy,
  globalInjection,
  locale,
  fallbackLocale,
  messages: localeMessages,
  allowComposition: true,
}) as { install: (app: App<I18nOptions>) => any };
